import { useState } from "react";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import { api } from "@/lib/api";

const KEY = "vt-help-votes";
const votes = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };
export const qid = (q) => q.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 100);

export const HelpFeedback = ({ question, section }) => {
  const id = qid(question);
  const [vote, setVote] = useState(() => votes()[id]);
  const send = (helpful) => {
    if (vote === helpful) return;
    const previous = vote;
    setVote(helpful);
    localStorage.setItem(KEY, JSON.stringify({ ...votes(), [id]: helpful }));
    api.post("/help/feedback", { question_id: id, question, section, helpful, previous: previous ?? null }).catch(() => {});
  };
  const btn = (on) => `inline-flex items-center gap-1 rounded-full border px-3 h-8 text-xs font-medium transition-colors ${on ? "bg-primary text-primary-foreground border-primary" : "hover:border-primary hover:text-primary"}`;
  return (
    <div className="mt-3 pt-3 border-t border-dashed flex flex-wrap items-center gap-2" data-testid={`help-feedback-${id}`}>
      <span className="text-xs text-muted-foreground">{vote === undefined ? "¿Te sirvió esta respuesta?" : vote ? "¡Gracias! Nos alegra que te sirviera." : "Gracias, la mejoraremos."}</span>
      <button type="button" onClick={() => send(true)} className={btn(vote === true)} aria-pressed={vote === true} data-testid={`help-yes-${id}`}><ThumbsUp className="w-3.5 h-3.5" />Sí</button>
      <button type="button" onClick={() => send(false)} className={btn(vote === false)} aria-pressed={vote === false} data-testid={`help-no-${id}`}><ThumbsDown className="w-3.5 h-3.5" />No</button>
    </div>
  );
};
